import { AgentInLenderContext, AgentInSinglePaymentProviderContext, Pricing } from '@nemuru-eng/js-api-client';

import { AgentInSinglePaymentProviderContextRow } from '@/components/modules/AgentDetail/ProvidersDetails/components/Credentials/components/AgentInSinglePaymentProviderContextTable/components/AgentInSinglePaymentProviderContextRow';
import { DefaultTableProps } from '@/types/defaultTableProps';
interface TableBodyContentProps {
  agentInContextArray: AgentInLenderContext[] | AgentInSinglePaymentProviderContext[];
  agentPricings: Pricing[];
  handleDeleteCredentials: ({ agentCredentials }: { agentCredentials: AgentInSinglePaymentProviderContext }) => void;
  handleEditCredentials: ({ agentCredentials }: { agentCredentials: AgentInSinglePaymentProviderContext }) => void;
  tableProps: Omit<DefaultTableProps, 'isScrollable'>;
  isMobile: boolean;
  hideColumnsForDeleteMode?: boolean;
}
export const TableBody = ({
  agentInContextArray,
  handleDeleteCredentials,
  handleEditCredentials,
  tableProps,
  hideColumnsForDeleteMode,
}: TableBodyContentProps) => {
  return (
    <>
      {agentInContextArray.map((agentInSinglePaymentProviderContext) => {
        return (
          <AgentInSinglePaymentProviderContextRow
            key={agentInSinglePaymentProviderContext.id}
            agentInSinglePaymentProviderContext={agentInSinglePaymentProviderContext}
            handleEditCredentials={handleEditCredentials}
            handleDeleteCredentials={handleDeleteCredentials}
            tableProps={tableProps}
            hideColumnsForDeleteMode={hideColumnsForDeleteMode}
          />
        );
      })}
    </>
  );
};
